import apiClient from './api';
import { Cliente, CreateClienteDTO, UpdateClienteDTO, PaginationParams, ApiResponse, PaginatedResponse } from '../types';

export const clienteService = {
  async getAll(params?: PaginationParams): Promise<PaginatedResponse<Cliente>> {
    const queryParams = new URLSearchParams();
    
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.pageSize) queryParams.append('pageSize', params.pageSize.toString());
    if (params?.search) queryParams.append('search', params.search);
    if (params?.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params?.sortOrder) queryParams.append('sortOrder', params.sortOrder);

    const response = await apiClient.get<ApiResponse<PaginatedResponse<Cliente>>>(
      `/clientes?${queryParams.toString()}`
    );
    
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || 'Erro ao buscar clientes');
    }
    
    return response.data.data;
  },

  async getById(id: string): Promise<Cliente> {
    const response = await apiClient.get<ApiResponse<Cliente>>(`/clientes/${id}`);
    
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || 'Cliente não encontrado');
    }
    
    return response.data.data;
  },

  async create(cliente: CreateClienteDTO): Promise<Cliente> {
    const response = await apiClient.post<ApiResponse<Cliente>>('/clientes', cliente);
    
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || 'Erro ao criar cliente');
    }
    
    return response.data.data;
  },

  async update(id: string, cliente: UpdateClienteDTO): Promise<Cliente> {
    const response = await apiClient.put<ApiResponse<Cliente>>(`/clientes/${id}`, cliente);
    
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || 'Erro ao atualizar cliente');
    }
    
    return response.data.data;
  },

  async delete(id: string): Promise<void> {
    const response = await apiClient.delete<ApiResponse<void>>(`/clientes/${id}`);
    
    if (!response.data.success) {
      throw new Error(response.data.message || 'Erro ao deletar cliente');
    }
  },

  async syncFromWrike(): Promise<{
    totalProcessed: number;
    totalReceived: number;
    tempoDecorrido: string;
    velocidade: string;
  }> {
    const response = await apiClient.post<ApiResponse<{
      totalProcessed: number;
      totalReceived: number;
      tempoDecorrido: string;
      velocidade: string;
    }>>('/clientes/sincronizar-wrike');
    
    if (!response.data.success || !response.data.data) {
      throw new Error(response.data.message || 'Erro ao sincronizar com Wrike');
    }
    
    return response.data.data;
  }
};
